export default "__VITE_ASSET__2WCy5Ryk__"